import { useMutation } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import mutationFn from "ApiLayer/Equipment/deleteEquipmentSurvey";
import useAlert from "hooks/useAlert";
import { showMutationAlert } from "utils/helpers";
import { useResetRecommendedBMCRPQueries } from "hooks/useResetRecommendedBMCRPQueries";

export const useDeleteEquipmentData = (buildingModelUid: string, onSuccess: () => void, onError: () => void) => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const resetRecommendedBMCRPQueries = useResetRecommendedBMCRPQueries(buildingModelUid);

    return useMutation({
        mutationFn: async () => mutationFn(accessToken, buildingModelUid),
        onSuccess: () => {
            onSuccess();
            resetRecommendedBMCRPQueries();
        },
        onError: (errors) => {
            onError();
            showMutationAlert(errors, alert);
        },
    });
};
